/**
 * FreeSpinsIntroOutroView
 *
 * Handles the view functionality of the free spins dialog(s)
 */
(function () {
  class FreeSpinsIntroOutro extends PIXI.Container {
    constructor() {
      super();

      this._callback = undefined;

      this.visible = false;

      this._spinsWon = undefined;
      this._outroPanel = undefined;
      this._freeSpinsIntroAnimatedPanel = undefined;
      this._cashWon = undefined;

      this._upgradeContainers = [];

      this._pressStartBox = undefined;
      this._introActive = false;
    }

    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this._gambleBacker = resourceManager.get("gambleBacker");
      this._fullPanel = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro");

      this._spinsWon = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:introPanel:numFreeSpinsText"
      );

      this._introPanel = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:introPanel");
      this._introPanel.visible = false;

      this._outroPanel = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:outroPanel");
      this._outroPanel.visible = false;

      this._congratsText = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:outroPanel:congratulationsText"
      );

      this._freeSpinsIntroAnimatedPanel = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:gambleIntroAnimatedPanel"
      );
      this._freeSpinsIntroAnimatedPanel.play();

      const cont10 = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:introPanel:upgrade10Container"
      );

      const cont15 = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:introPanel:upgrade15Container"
      );
      this._before15 = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:introPanel:upgrade15Container:fishCont:salmon"
      );
      this._after15 = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:introPanel:upgrade15Container:fishCont:trout2"
      );
      this._part15 = particleManager.createEmitter(
        "upgradeEmitter",
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:introPanel:upgrade15Container:particleContainer",
        0,
        0,
        false
      );
      this._part15.particleEmitter.emit = false;

      const cont20 = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:introPanel:upgrade20Container"
      );
      this._before20 = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:introPanel:upgrade20Container:before"
      );
      this._after20 = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:introPanel:upgrade20Container:after"
      );
      this._part20 = particleManager.createEmitter(
        "upgradeEmitter",
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:introPanel:upgrade20Container:particleContainer",
        0,
        0,
        false
      );
      this._part20.particleEmitter.emit = false;

      this._upgradeContainers = [cont10, cont15, cont20];

      this._cashWon = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:outroPanel:cashWonText");
      this._cashWon.visible = false;

      this._pressStartBox = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:pressStartColourBox");

      this._pressStartBox.alpha = 0;
      this._pressStartBox.visible = false;
      this._pressStartBox.interactive = false;

      const continueText1 = resourceManager.get("freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:introPanel:continueContainer");

      gsap.to(continueText1, {
        duration: 0.8,
        pixi: { scaleX: 0.92, scaleY: 0.92 },
        yoyo: true,
        repeat: -1,
        ease: "power1.inOut",
      });

      const continueText2 = resourceManager.get(
        "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro:outroPanel:pressToContinueButton:continueContainer"
      );

      gsap.to(continueText2, {
        duration: 0.8,
        pixi: { scaleX: 0.92, scaleY: 0.92 },
        yoyo: true,
        repeat: -1,
        ease: "power1.inOut",
      });
    }

    playUpgrade15Anim() {
      const duration = 0.1;
      const delay = 0.2;

      this._part15.particleEmitter.emit = true;

      gsap.to(this._before15, { duration, delay, alpha: 0 });

      gsap.to(this._after15, {
        duration,
        delay,
        alpha: 1,
      });
    }

    playUpgrade20Anim() {
      const duration = 0.1;
      const delay = 0.2;

      this._part20.particleEmitter.emit = true;

      gsap.to(this._before20, { duration, delay, alpha: 0 });

      gsap.to(this._after20, {
        duration,
        delay,
        alpha: 1,
      });
    }

    setup() {
      this._pressStartBox.visible = true;
      this._pressStartBox.alpha = 0;
    }

    showIntro(numFS, callback) {
      musicManager.onFreespinsIntro();

      resourceManager.getContainer("gambleIntroContainer").visible = true;

      gameController.canSlamStop = false;

      this._introActive = true;
      this.setup();

      this._callback = callback;
      this._outroPanel.visible = false;
      this._introPanel.visible = true;
      this._cashWon.visible = false;

      switch (numFS) {
        default:
        case 10:
          this._upgradeContainers[0].visible = true;
          this._upgradeContainers[1].visible = false;
          this._upgradeContainers[2].visible = false;
          break;

        case 15:
          this._upgradeContainers[0].visible = false;
          this._upgradeContainers[1].visible = true;
          this._upgradeContainers[2].visible = false;
          break;

        case 20:
          this._upgradeContainers[0].visible = false;
          this._upgradeContainers[1].visible = false;
          this._upgradeContainers[2].visible = true;
          break;
      }

      this._spinsWon.setTranslationParameters(numFS);

      gameController.fullScreenBubblesFront.startBubbles();
      timerManager.addTimeout(500, function () {
        gameController.fullScreenBubblesFront.stopBubbles();
      });
      gameController.fullScreenBubblesBack.startBubbles();

      this.fadeIn(this._gambleBacker, 0.8, 1.0, 0.0);

      this._before15.alpha = 1;
      this._after15.alpha = 0;
      this._before20.alpha = 1;
      this._after20.alpha = 0;

      this.floatIn(this._fullPanel, 0, 2, () => {
        this.playUpgrade15Anim();
        this.playUpgrade20Anim();
      });
      this.fadeIn(this._fullPanel, 1.0, 0.75, 0);

      let self = this;
      timerManager.addTimeout(1000, function () {
        self.setActive();
      });

      soundManager.play("dialogIn");
    }

    floatIn(object, delay, duration, cb = undefined) {
      gsap.fromTo(
        object,
        {
          x: 0,
          y: 500,
        },
        {
          delay,
          duration,
          ease: "elastic.out(1.0, 0.4)",
          x: 0,
          y: 0,
          onStart: () => {
            this._fullPanel.visible = true;
          },
          onComplete: () => {
            if (cb) {
              cb();
            }
          },
        }
      );
    }

    fadeIn(object, alpha, duration, delay) {
      gsap.fromTo(
        object,
        {
          alpha: 0,
        },
        {
          delay: delay,
          duration: duration,
          alpha: alpha,
          onStart: () => {
            object.visible = true;
          },
        }
      );
    }

    bounceIn(object, delay, duration, scale) {
      gsap.fromTo(
        object.scale,
        {
          x: 0,
          y: 0,
        },
        {
          delay: delay,
          duration: duration ?? 1,
          ease: "Bounce.easeOut",
          x: scale ?? 1,
          y: scale ?? 1,
          onStart: () => {
            object.visible = true;
            object.alpha = 1;
          },
          onComplete: () => {
            this.setActive();
          },
        }
      );
    }

    setActive() {
      this._pressStartBox.interactive = true;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart = this.closeDialog.bind(this);
    }

    showOutro(cashWon, callback) {
      musicManager.onFreespinsOutro();

      gameController.canSlamStop = false;

      gameController.fullScreenBubblesFront.startBubbles();
      timerManager.addTimeout(500, function () {
        gameController.fullScreenBubblesFront.stopBubbles();
      });
      gameController.fullScreenBubblesBack.startBubbles();

      this.fadeIn(this._gambleBacker, 0.8, 1.0, 0.0);

      this._introActive = false;
      this._fullPanel.visible = true;
      this.setup();

      this._callback = callback;

      this._outroPanel.visible = true;
      this._introPanel.visible = false;

      this._cashWon.visible = true;

      this.floatIn(this._fullPanel, 0, 2);
      this.fadeIn(this._fullPanel, 1.0, 0.75, 0);

      soundManager.play("free_spins_end");

      let self = this;
      timerManager.addTimeout(1500, function () {
        self.setActive();
      });

      this._cashWon.setText(gdk.formatCurrency(cashWon));

      if (cashWon > 0) {
        this._congratsText.setTranslationPhrase("t_Congratulations");
      } else {
        this._congratsText.setTranslationPhrase("t_betterLuckNextTime");
      }
    }

    closeDialog() {
      let reels = resourceManager.get("slotContainer:reelContainer");
      reels.alpha = 1.0;

      this._pressStartBox.visible = false;
      this._pressStartBox.alpha = 0;
      this._pressStartBox.interactive = false;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart = undefined;

      soundManager.play("buttonPressV1");

      soundManager.play("dialogOut");

      if (this._introActive) {
        musicManager.onFreespinsStart(0);
        this.clearIntro();
      } else {
        this.clearOutro();
      }
    }

    clearIntro() {
      this.fadeOut(this._gambleBacker, 1.0);
      this.riseUp(this._fullPanel, 1.0);

      timerManager.addTimeout(500, function () {
        gameController.fullScreenBubblesBack.stopBubbles();
      });

      const self = this;
      timerManager.addTimeout(1000, function () {
        self._callback();
      });
    }

    clearOutro() {
      this.fadeOut(this._gambleBacker, 1.0);
      this.riseUp(this._fullPanel, 1.0);

      gameController.fullScreenBubblesFront.stopBubbles();
      gameController.fullScreenBubblesBack.stopBubbles();

      const self = this;
      timerManager.addTimeout(500, function () {
        self._callback();
      });
    }

    fadeOut(object, duration) {
      gsap.to(object, {
        duration: duration,
        alpha: 0,
        ease: "power1.in",
        onComplete: () => {
          object.visible = false;
          object.alpha = 1;
        },
      });
    }

    riseUp(object, duration, cb) {
      const originalPosition = {
        x: gsap.getProperty(object, "x"),
        y: gsap.getProperty(object, "y"),
      };

      gsap.to(object, {
        duration: duration,
        x: 0,
        y: -1000,
        ease: "power4.in",
        onComplete: () => {
          object.visible = false;
          gsap.set(object, { x: originalPosition.x, y: originalPosition.y });
          if (cb) {
            cb();
          }
        },
      });
    }
  }

  let freeSpinsIntroOutroCreator = function (json) {
    return new FreeSpinsIntroOutro();
  };

  let freeSpinsIntroOutroInitialiser = function (json, disclaimer) {
    disclaimer.initialise();
  };

  let freeSpinsIntroOutroFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "FreeSpinsIntroOutro",
    freeSpinsIntroOutroCreator,
    freeSpinsIntroOutroInitialiser,
    freeSpinsIntroOutroFilesRequired
  );
})();
